import { Box, Container, Stack, Text, Title } from "@mantine/core";
import GetHelpForm from "./Shared/GetHelpForm";
import Seo from "../seo/Seo";
import {
  createBreadcrumbSchema,
  createOrganizationSchema,
} from "../seo/utils";
import "./AssignmentHelp/AssignmentHelp.css";

function ContactPage() {
  return (
    <main className="assignment-landing">
      <Seo
        title="Contact SubjectBuddy | Get Assignment Help"
        description="Contact SubjectBuddy for subject-specific assignment help, academic guidance, coursework planning, draft improvement, and urgent deadline support."
        path="/contact"
        schema={[
          createOrganizationSchema(),
          createBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Contact", path: "/contact" },
          ]),
        ]}
      />

      <Box component="section" py={{ base: 70, md: 110 }}>
        <Container size="md">
          <Stack gap="xl">
            <Stack gap="md" ta="center">
              <Title order={1}>Get Assignment Help</Title>
              <Text c="dimmed" size="lg" style={{ lineHeight: 1.8 }}>
                Share your subject, brief, deadline, and marking criteria. The
                SubjectBuddy team will review your request and guide you toward
                the right academic support.
              </Text>
            </Stack>

            <GetHelpForm formSize="md" />
          </Stack>
        </Container>
      </Box>
    </main>
  );
}

export default ContactPage;
